export let LABLES = {
    NAME: "Name",
    EMAIL: "Email",
    AGE: "Age",
    STATUS: "Status",
    SUBSCRIPTION_PLAN: "Subscription Plan",
    ACTION: "Action"
};

export const filterOptions = [
    {
        label: "Active",
        value: "Active"
    },
    {
        label: "Inactive",
        value: "Inactive"
    }
];

export const subsCriptionfilterOptions = [
    {
        label: "Premium",
        value: "Premium"
    },
    {
        label: "Freemium",
        value: "Freemium"
    }
];
